module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.11-113.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.11.md
// module id = 530
// module chunks = 285